import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-tile',
  templateUrl: './tile.component.html'
})
export class TileComponent implements OnInit {

  @Input() title: string;
  @Input() hint: string;

  constructor() { }

  ngOnInit() {
  }

}
